import { useEffect, useState } from "react";
import { notification } from "antd";

import { IClient } from "@/modules/client/clients.interface";
import { ClientHttpService } from "@/modules/client/services/client-http.service";
import { getFriendlyErrorMessage } from "@/shared/services/http";

export function useAllClientsHook() {
  const [clients, setClients] = useState<IClient[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        setIsLoading(true);
        const data: IClient[] = await ClientHttpService.getAllClients();
        setClients(data);
      } catch (error) {
        setHasError(true);
        const message = getFriendlyErrorMessage(error) ?? "Failed to load clients. Please try again.";
        notification.error({ message });
      } finally {
        setIsLoading(false);
      }
    };

    fetchClients();
  }, []);

  return { clients, isLoading, hasError };
}
